import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

const method = api.getLoansCustomerEarliestvalidfilterdate;

function getEarliestValidFilterDateQuery(opts: RequestOpts = {}) {
  const queryKey = ['getEarliestValidFilterDate'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return method({
        ...opts,
        signal,
      });
    },
    retry: true,
    staleTime: ms('5m'),
    gcTime: ms('10m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchEarliestValidFilterDateQuery(
  opts: RequestOpts = {},
) {
  return queryClient.fetchQuery(getEarliestValidFilterDateQuery(opts));
}
